<template>
  <v-combobox v-model="selectedValue" :items="availableItems" :hide-no-data="!search" :search-input.sync="search"
    smalll-chips outlined dense clearable :label="label"
    @input="event => { $emit('input', event); $emit('change', event); }" :hide-details="true"
    :background-color="backgroundColor" @update:search-input="querySelections">
  </v-combobox>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      selectedValue: null,
      loading: false,
      availableItems: [],
      search: null
    };
  },
  props: {
    label: null,
    multiple: null,
    items: null,
    value: null,
    backgroundColor: null
  },
  created() {
    this.availableItems = this.items;
  },
  mounted() {
    this.selectedValue = this.value
  },
  watch: {
    value: {
      handler: function (newValue) {
        if (!newValue)
          this.selectedValue = null;
      },
    },
  },
  methods: {
    async querySelections(v) {
      this.loading = true;
      if (this.items.length == 0) {
        var r = await Api().get('admins/academy/' +
          this.$store.state.selectedAcademy + '/tags');
        if (r.data)
          this.availableItems = r.data.sort();
      }
      this.availableItems = this.items.filter(e => {
        return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
      });
      this.loading = false;
    }
  }
};
</script>

<style scoped></style>
